import React from 'react';
import { LayersIcon, ImageIcon } from 'lucide-react';
import { Template } from '../lib/data';
import { Card, CardContent } from './ui/Card';
import { Button } from './ui/Button';
interface TemplateCardProps {
  template: Template;
}
export function TemplateCard({
  template
}: TemplateCardProps) {
  return <Card className="group overflow-hidden border-border hover:border-blue-300 hover:shadow-md transition-all duration-300 flex flex-col h-full" data-id="element-195">
      {/* Placeholder Image Area */}
      <div className="aspect-video w-full bg-muted relative flex items-center justify-center" data-id="element-196">
        <ImageIcon className="w-10 h-10 text-muted-foreground/40" data-id="element-197" />
      </div>

      {/* Content Area */}
      <CardContent className="px-3 py-3 flex flex-col flex-grow" data-id="element-198">
        <h3 className="font-semibold text-sm text-foreground group-hover:text-blue-600 transition-colors mb-1" data-id="element-199">
          {template.title}
        </h3>

        <p className="text-xs text-muted-foreground line-clamp-2 mb-3 flex-grow" data-id="element-200">
          {template.description}
        </p>

        <div className="flex items-center justify-between mt-auto pt-3 border-t border-border" data-id="element-201">
          <div className="flex items-center text-muted-foreground text-xs font-medium" data-id="element-202">
            <LayersIcon className="w-3.5 h-3.5 mr-1" data-id="element-203" />
            {template.stepCount} pages
          </div>
          <Button variant="outline" size="sm" className="px-3 py-1.5 h-auto text-xs font-semibold hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200" data-id="element-204">
            Use This →
          </Button>
        </div>
      </CardContent>
    </Card>;
}